// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Wv-z","tooltipWrapper":"Xv-z","icon":"Yv-z","tooltip":"Zv-z","content":"_v-z"};